import { useCallback, useEffect, useState, type ReactNode } from "react";
import { ThemeContext } from "./theme-context";

export type Theme = "light" | "dark";

type ThemeProviderProps = {
  children: ReactNode;
};

const defaultTheme = "dark";

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const [theme, setTheme] = useState<Theme>(defaultTheme);

  useEffect(() => {
    document.documentElement.classList.add(defaultTheme);
  }, []);

  const updateTheme = useCallback(
    (newTheme: Theme) => {
      setTheme(newTheme);
      document.documentElement.classList.replace(theme, newTheme);
    },
    [theme]
  );

  return (
    <ThemeContext.Provider value={{ theme, updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
